import { render, staticRenderFns } from "./NewsSearchForm.vue?vue&type=template&id=21b27b27&"
import script from "./NewsSearchForm.vue?vue&type=script&lang=js&"
export * from "./NewsSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports